import { render, staticRenderFns } from "./download-button.vue?vue&type=template&id=b9bde06a&scoped=true&functional=true&"
import script from "./download-button.vue?vue&type=script&lang=js&"
export * from "./download-button.vue?vue&type=script&lang=js&"
import style0 from "./download-button.vue?vue&type=style&index=0&id=b9bde06a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b9bde06a",
  null
  
)

export default component.exports